import React from 'react';
export function Footer() {
  return <footer className="py-8 border-t border-border bg-dark" data-id="element-137">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-138">
        <span className="text-sm text-secondary font-medium" data-id="element-139">
          © {new Date().getFullYear()} Karan Dhir
        </span>
        <div className="flex items-center gap-6 text-sm text-secondary font-medium" data-id="element-140">
          <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-141">
            LinkedIn
          </a>
          <a href="https://substack.com/@karandhir" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-142">
            Substack
          </a>
          <a href="https://github.com/kd-511" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-143">
            GitHub
          </a>
        </div>
      </div>
    </footer>;
}